// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"320":"17471465","443":"5ed71bf9","523":"a2d8cc59"}[chunkId] + ".js";
};